import axios from "axios";

let token = document.head.querySelector('meta[name="csrf-token"]')
let accessToken = document.head.querySelector('meta[name="access-token"]')

const instance = axios.create({
    baseURL: '/api/v1/',
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': token.content,
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
})

export default instance